'use client'

import { useState } from 'react'
//import { z } from "zod";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/platform/v2/ui/dialog'
import { Button } from '@/components/platform/v2/ui/button'
import { Input } from '@/components/platform/v2/ui/input'
import { Label } from '@/components/platform/v2/ui/label'
import { Checkbox } from '@/components/platform/v2/ui/checkbox'
import { toast } from '@/hooks/use-toast'

/*const schema = z.object({
  email: z.string().trim().email("Введите корректный email").max(255),
  consent: z.literal(true, { errorMap: () => ({ message: "Необходимо согласие на рассылку" }) }),
});*/

interface Props {
    open: boolean
    onOpenChange: (open: boolean) => void
    title?: string
}

export const SubscribeReminderDialog = ({ open, onOpenChange, title = 'Подписаться на напоминания' }: Props) => {
    const [email, setEmail] = useState('')
    const [consent, setConsent] = useState(false)
    const [submitting, setSubmitting] = useState(false)

    const reset = () => {
        setEmail('')
        setConsent(false)
    }

    const handleClose = (next: boolean) => {
        if (!next) reset()
        onOpenChange(next)
    }

    /*const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const parsed = schema.safeParse({ email, consent });
    if (!parsed.success) {
      toast({ title: "Проверьте данные", description: parsed.error.issues[0].message, variant: "destructive" });
      return;
    }
    setSubmitting(true);
    try {
      const subs = JSON.parse(localStorage.getItem("event-reminders") || "[]");
      subs.push({ email: parsed.data.email, createdAt: new Date().toISOString() });
      localStorage.setItem("event-reminders", JSON.stringify(subs));
      toast({ title: "Готово!", description: "Мы пришлём напоминания о ближайших мероприятиях." });
      handleClose(false);
    } finally {
      setSubmitting(false);
    }
  };*/

    return (
        <Dialog open={open} onOpenChange={handleClose}>
            <DialogContent className="max-w-md">
                <DialogHeader>
                    <DialogTitle className="font-montserrat-semibold">{title}</DialogTitle>
                    <DialogDescription className="font-montserrat">
                        Оставьте email, и мы пришлём напоминания о ближайших мероприятиях.
                    </DialogDescription>
                </DialogHeader>
                <form /*onSubmit={handleSubmit}*/ className="space-y-4 mt-2">
                    <div className="space-y-2">
                        <Label htmlFor="reminder-email">Email</Label>
                        <Input
                            id="reminder-email"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="you@example.com"
                            maxLength={255}
                            required
                        />
                    </div>
                    <div className="flex items-start gap-2">
                        <Checkbox
                            id="reminder-consent"
                            checked={consent}
                            onCheckedChange={(v: any) => setConsent(v === true)}
                            className="mt-0.5"
                        />
                        <Label htmlFor="reminder-consent" className="text-sm font-montserrat font-normal leading-snug cursor-pointer">
                            Согласен(на) на получение рассылок и обработку персональных данных
                        </Label>
                    </div>
                    <Button type="submit" variant="site" disabled={submitting} className="w-full">
                        {submitting ? 'Отправка...' : 'Подписаться'}
                    </Button>
                </form>
            </DialogContent>
        </Dialog>
    )
}
